import { useLanguage } from '@/contexts/LanguageContext';

export default function ContactHero() {
  const { t } = useLanguage();

  const tags = [
    { icon: 'ri-flask-line', label: t('技術諮詢', 'Tech Consultation', '技術相談') },
    { icon: 'ri-test-tube-line', label: t('試產驗證', 'Pilot Production', '試験生産') },
    { icon: 'ri-shopping-cart-line', label: t('材料採購', 'Material Procurement', '材料調達') },
    { icon: 'ri-team-line', label: t('經銷合作', 'Distribution Partnership', '販売代理') },
    { icon: 'ri-leaf-line', label: 'ESG ' + t('專案', 'Projects', 'プロジェクト') },
  ];

  return (
    <section className="relative min-h-[420px] md:min-h-[500px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-top"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=professional%20business%20meeting%20consultation%20sustainable%20materials%20company%20office%20modern%20clean%20environment%20green%20technology%20B2B%20corporate%20photography%20wide%20angle%20green%20and%20blue%20accent%20lighting%20high%20resolution%20Taiwan%20industrial&width=1440&height=500&seq=contact-hero-v1&orientation=landscape)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/25 to-black/10" />
      <div
        className="absolute top-0 right-0 w-[550px] h-[550px] opacity-18 pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgba(0,184,148,0.28) 0%, transparent 65%)', zIndex: 2 }}
        aria-hidden="true"
      />

      <div className="relative w-full max-w-screen-xl mx-auto px-4 md:px-6 py-16" style={{ zIndex: 3 }}>
        <div className="max-w-[680px] bg-black/20 backdrop-blur-[2px] rounded-2xl px-8 py-8 md:px-10 md:py-10">
          <p className="text-[1rem] font-semibold text-brand-green uppercase tracking-widest mb-4">
            {t('聯絡我們', 'Contact Us', 'お問い合わせ')}
          </p>
          <h1
            className="font-bold text-white mb-6"
            style={{ fontSize: 'clamp(2rem, 4vw, 2.75rem)', lineHeight: '1.3' }}
          >
            {t(
              '讓我們一起評估，如何把廢棄塑膠變成可落地的循環材料方案',
              'Let\'s Evaluate Together How to Turn Waste Plastics into Actionable Circular Material Solutions',
              '廃プラスチックを実用的なサーキュラー材料ソリューションへ転換する方法を一緒に評価しましょう'
            )}
          </h1>
          <p
            className="text-white/85 mb-9 max-w-[600px]"
            style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}
          >
            {t(
              '不論您是塑膠回收廠、造粒廠、射出押出製造商、品牌端、經銷商、政府單位或 ESG 專案團隊，都可以與聚量討論技術導入、試產驗證、材料採購、經銷合作與低碳產品開發。',
              'Whether you are a plastic recycler, compounder, injection/extrusion manufacturer, brand owner, distributor, government agency, or ESG project team — contact PolyQ to discuss technology implementation, pilot production, material procurement, distribution partnerships, and low-carbon product development.',
              'プラスチックリサイクル業者・造粒業者・射出押出メーカー・ブランドオーナー・販売代理店・政府機関・ESGプロジェクトチームを問わず、技術導入・試験生産・材料調達・販売代理・低炭素製品開発について聚量にご相談ください。'
            )}
          </p>
          <div className="flex flex-wrap gap-2.5">
            {tags.map((tag) => (
              <div key={tag.label} className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-white/10 border border-white/25 backdrop-blur-sm">
                <i className={`${tag.icon} text-brand-green text-sm`}></i>
                <span className="text-white/90 text-[0.9375rem] font-medium whitespace-nowrap">{tag.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
